/**
 * @module-isolated analytics-resumen-ejecutivo
 */
import { fetchExecutiveSummary } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';
import { withSessionCache } from '../../../shared/utils/session-cache.js';

function cacheKey_(filters) {
  return (
    'execSummary:' +
    String((filters && filters.dateFrom) || '') +
    '|' +
    String((filters && filters.dateTo) || '')
  );
}

/**
 * @param {{ dateFrom?: string, dateTo?: string, force?: boolean }} filters
 * @param {{ force?: boolean }} [opts]
 */
export async function loadExecutiveSummary(filters, opts) {
  const force = !!(opts && opts.force) || !!(filters && filters.force);
  return withSessionCache(
    cacheKey_(filters),
    async () => {
      const token = await getIdToken(false);
      const data = await fetchExecutiveSummary(
        {
          dateFrom: filters && filters.dateFrom,
          dateTo: filters && filters.dateTo,
          force
        },
        token
      );
      return data;
    },
    { force }
  );
}
